import { Outlet, NavLink, Link } from "react-router-dom";
import "./AdminLayout.css";

const NAV = [
  ["/admin", "Overview"],
  ["/admin/review", "Needs review"],
  ["/admin/orders", "Orders"],
  ["/admin/products", "Products"],
  ["/admin/users", "Users"],
  ["/admin/banners", "Banners"],
  ["/admin/announce", "Announce"],
  ["/admin/audit", "Audit log"],
  ["/admin/offers", "Offers"],
  ["/admin/payments", "UPI Logs"],
];

export default function AdminLayout() {
  return (
    <div className="adm">
      <aside className="adm-side">
        <Link to="/" className="adm-back">← Back to store</Link>
        <nav>
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/admin"} className={({ isActive }) => (isActive ? "on" : "")}>
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="adm-main"><Outlet /></div>
    </div>
  );
}
